module.exports = __webpack_public_path__ + "static/media/arrows-h.65c108bd.svg";